import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { ProfileDisplay } from "../../components/account/ProfileQuestions/ProfileDisplay";
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getSingleAccount, getStatuses } from "../../controllers/accounts/accounts";
import { useParams } from "react-router-dom";
import { useProfileComplete } from "../../hooks/useProfileComplete";

export const AccountShow = ({ swipe_id }) => {
  const { userDetails } = useContext(UserContext);
  const { user_id } = useParams();
  const token = userDetails?.token ?? "";
  const [max_id, setMaxID] = useState(null);
  const [media, setMedia] = useState([]);
  const [account, setAccount] = useState(null);
  
  // Check profile completion and redirect if needed
  useProfileComplete(userDetails);

  let id = user_id ? user_id : swipe_id;

  const { data: statuses, refetch } = useQuery({
    queryKey: ["getStatuses" + id + "Account"],
    queryFn: () => getStatuses(id, token, max_id),
  });

  const isInMedia = (id) => {
    return media.some((x) => x.id === id);
  };

  useEffect(() => {
    setMedia([]);
    if (statuses?.length > 0) {
      statuses?.forEach((item) => {
        if (!isInMedia(item.id) && item.visibility === "public") {
          if (item.media_attachments?.length > 0 && !media.includes(item.media_attachments[0].url && !media.includes(item.content))) {
            setMedia((media) => [
              ...media,
              { img: item.media_attachments[0].url, avatar: null, id: item.id },
            ]);
          } else {
            setMedia((media) => [
              ...media,
              { img: item.content, avatar: null, id: item.id },
            ]);
          }
        }
      });
    }
  }, [statuses]);

  useEffect(() => {
  // NEXT PGE OF STATUSES
    /*if (statuses?.length > 0 && media?.length === 0) {
      setMaxID(statuses[statuses?.length - 1].id);
    }*/
  }, [media, statuses]);

  useEffect(() => {
    refetch();
    if(userDetails?.id === id){
      setAccount(userDetails)
    } else {
      getSingleAccount(id, token)
        .then((res) => {
          setAccount({...res.account, user:res?.mastodon?.user?.[0]});
        })
        .catch((err) => {
          console.error("Error fetching account:", err);
        });
    }
  }, [id]);


  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isCloseToBottom = scrollTop + clientHeight >= scrollHeight - 10; // Adjust the threshold as needed
    if (isCloseToBottom && statuses?.length > 0) {
      setMaxID(statuses[statuses?.length - 1].id);
    }
  };

  return (
    <ProfileDisplay
      id={id}
      userDetails={userDetails}
      account={account?.id === id ? account : null}
      token={token}
      handleScroll={handleScroll}
      media={media}
      swipe_card={!!swipe_id}
    />
  );
};